import {
    REQUEST_PURCHASE_SCHEDULES,
    FETCH_PURCHASE_SCHEDULES_SUCCESS,
    FETCH_PURCHASE_SCHEDULES_FAILURE,
    SELECT_PURCHASE_SCHEDULE,
    RESET_CURRENT_PURCHASE_SCHEDULE,
    REQUEST_PURCHASE_SCHEDULE_DETAIL,
    FETCH_PURCHASE_SCHEDULE_DETAIL_SUCCESS,
    FETCH_PURCHASE_SCHEDULE_DETAIL_FAILURE,
    REQUEST_CREATING_PURCHASE_SCHEDULE,
    CREATE_PURCHASE_SCHEDULE_SUCCESS,
    CREATE_PURCHASE_SCHEDULE_FAILURE,
    REQUEST_EDITING_PURCHASE_SCHEDULE,
    EDIT_PURCHASE_SCHEDULE_SUCCESS,
    EDIT_PURCHASE_SCHEDULE_FAILURE
} from '../actions/type';

const INITIAL_STATE = {
    all: [],
    currentPurchaseSchedule: null,
    currentPurchaseScheduleDetail: null,
    isLoading: true,
    error: null,
    detailIsLoading: false,
    detailError: null,
    purchaseScheduleIsCreating: false,
    purchaseScheduleCreateError: null,
    purchaseScheduleCreated: false,
    purchaseScheduleIsEditing: false,
    purchaseScheduleEditError: null,
    purchaseScheduleEdited: false,
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        // Product action handlers
        case REQUEST_PURCHASE_SCHEDULES:
            return { ...state, error: null, isLoading: true };
        case FETCH_PURCHASE_SCHEDULES_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_PURCHASE_SCHEDULES_FAILURE:
            const error = action.payload || { message: action.payload.message };
            return { ...state, all: [], error: error, isLoading: false };
        case SELECT_PURCHASE_SCHEDULE:
            return {...state, currentPurchaseSchedule: action.payload };
        case RESET_CURRENT_PURCHASE_SCHEDULE:
            return { ...state, currentPurchaseSchedule: null, currentPurchaseScheduleDetail: null, 
                               purchaseScheduleEditError: null, purchaseScheduleCreateError: null,
                               purchaseScheduleIsEditing: false, purchaseScheduleIsCreating: false };
        case REQUEST_PURCHASE_SCHEDULE_DETAIL:
            return { ...state, detailError: null, detailIsLoading: true };
        case FETCH_PURCHASE_SCHEDULE_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentPurchaseScheduleDetail: action.payload, detailError: null, detailIsLoading: false };
        case FETCH_PURCHASE_SCHEDULE_DETAIL_FAILURE:// return error and make loading = false
            const detailError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], detailError: detailError, detailIsLoading: false };
        case REQUEST_CREATING_PURCHASE_SCHEDULE:
            return { ...state, purchaseScheduleIsCreating: true, purchaseScheduleCreateError: null, purchaseScheduleCreated: false };
        case CREATE_PURCHASE_SCHEDULE_SUCCESS:
            return { ...state, purchaseScheduleIsCreating: false, purchaseScheduleCreateError: null, purchaseScheduleCreated: true };
        case CREATE_PURCHASE_SCHEDULE_FAILURE:
            const purchaseScheduleCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, purchaseScheduleIsCreating: false, purchaseScheduleCreateError: purchaseScheduleCreateError, purchaseScheduleCreated: false };
        case REQUEST_EDITING_PURCHASE_SCHEDULE:
            return { ...state, purchaseScheduleIsEditing: true, purchaseScheduleEditError: null, purchaseScheduleEdited: false };
        case EDIT_PURCHASE_SCHEDULE_SUCCESS:
            return { ...state, purchaseScheduleIsEditing: false, purchaseScheduleEditError: null, purchaseScheduleEdited: true };
        case EDIT_PURCHASE_SCHEDULE_FAILURE:
            const purchaseScheduleEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, purchaseScheduleIsEditing: false, purchaseScheduleEditError: purchaseScheduleEditError, purchaseScheduleEdited: false };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/purchaseSchedules_reducer.js